import {
  ContentWrapper,
  WidgetContainerWrapper,
} from '@framework/engine-ui/dnd/sortable-widgets/SortableWidgetRender.styled.tsx';
import { FormComponent } from '@framework/engine-ui/widgets/FormComponent.tsx';
import React from 'react';
import { isContainer } from '../../widgets/repository/containers/IContainerWidget.ts';
import { type Widget } from '../../widgets/Widget.ts';
import { FillableWidgetList } from './FillableWidgetList.tsx';

export interface IFillableWidgetProps {
  widget: Widget;
  parent: Widget | undefined;
  readonly?: boolean;
  /** Permette di gestire dinamicamente il readonly per ogni singolo widget */
  isReadonly?: (widget: Widget) => boolean;
}

/**
 * Componente che gestisce la rappresentazione di un widget.
 * Come il componente SortableWidgetRender, ma senza la possibilità di essere trascinato,
 * e contenente un input compilabile e funzionante.
 */
export const FillableWidget = React.memo(
  function FillableWidget(props: IFillableWidgetProps) {
    const { widget, readonly, isReadonly } = props;
    const isOnlyWidgetReadonly = isReadonly?.(widget);
    const isWidgetReadonly = Boolean(readonly) || Boolean(isOnlyWidgetReadonly);

    return (
      <WidgetContainerWrapper>
        <ContentWrapper className="fillable-widget-wrapper">
          {isContainer(widget) ? (
            <FormComponent
              widget={widget}
              readonly={isWidgetReadonly}
              isOnlyWidgetReadonly={isOnlyWidgetReadonly}
            >
              <FillableWidgetList
                widgets={widget.children ?? []}
                parent={widget}
                readonly={readonly}
                isReadonly={isReadonly}
              />
            </FormComponent>
          ) : (
            <FormComponent
              widget={widget}
              readonly={isWidgetReadonly}
              isOnlyWidgetReadonly={isOnlyWidgetReadonly}
            />
          )}
        </ContentWrapper>
      </WidgetContainerWrapper>
    );
  },
  (prev, next) =>
    prev.widget === next.widget &&
    prev.readonly === next.readonly &&
    prev.isReadonly === next.isReadonly,
);
